import { render, staticRenderFns } from "./RecordView.vue?vue&type=template&id=4308e83c&"
import script from "./RecordView.vue?vue&type=script&lang=js&"
export * from "./RecordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports